<template>
  <div class="attachments">
    <div
      v-for="document in documents"
      :key="document.id"
    >
      <post-attachment class="attachment" :document="document" />
    </div>
  </div>
</template>

<script>
import PostAttachment from '@/components/post/PostAttachment'

export default {
  name: 'PostAttachments',
  components: { PostAttachment },
  props: {
    documents: {
      type: Array,
      required: false,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">
.attachments {
  margin-top: 6px;

  .attachment {
    background: #F2F2F2;
    padding-bottom: 12px;
    margin-left: 24px;
    font-weight: bold;
  }
}
</style>
